// src/components/SecurityWarningModal.tsx
import React from 'react';

interface SecurityWarningModalProps {
  isOpen: boolean;
  timeRemaining: number;
  onStayLoggedIn: () => void;
  onLogoutNow: () => void;
  formatTime: (ms: number) => string;
}

const SecurityWarningModal: React.FC<SecurityWarningModalProps> = ({
  isOpen,
  timeRemaining,
  onStayLoggedIn,
  onLogoutNow,
  formatTime
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Overlay */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>
        
        {/* Modal */}
        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
              <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.996-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 className="text-lg leading-6 font-medium text-gray-900">
                ⚠️ Session sur le point d'expirer
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  Votre session va expirer dans <strong className="text-red-600">{formatTime(timeRemaining)}</strong> par mesure de sécurité.
                </p>
                <p className="text-xs text-gray-400 mt-2">
                  Cliquez sur "Rester connecté" pour prolonger votre session ou "Se déconnecter" pour quitter maintenant.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              onClick={onStayLoggedIn}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-olive text-base font-medium text-white hover:bg-terracotta focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-olive sm:ml-3 sm:w-auto sm:text-sm"
            >
              Rester connecté
            </button>
            <button
              type="button"
              onClick={onLogoutNow}
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Se déconnecter
            </button>
          </div>
          
          {/* Barre de progression */}
          <div className="mt-4">
            <div className="bg-gray-200 rounded-full h-2">
              <div 
                className="bg-red-600 h-2 rounded-full transition-all duration-1000"
                style={{ width: `${Math.max(0, (timeRemaining / 60000) * 100)}%` }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityWarningModal;